import AppOptions from "../app/options";
import Html from "./html";
import Observer from './observer';
import Banners from '../libs/banners';
import BannerZoneModel from "../model/banner_zone";

declare var window: any;

class Proad {

    constructor(
        private html: Html,
        private options: AppOptions,
        private observer: Observer,
        private banners: Banners
        ) { }

    load(): void {
        const url = '/nc/proad' +
            '?article_id=' + this.getArticleId() +
            '&is_mobile=' + (this.options.isMobile ? 1 : 0) +
            '&section_id=' + this.options.sectionId +
            '&categories=' + encodeURIComponent(this.options.categories);

        this.html.fetchText(url)
            .then(html => {

                this.html.writeHTML('#proad', html);

                this.appendBanner();

                const elements = this.html.qAll('.proad-stat[inview]');

                if (!elements.length) {
                    return;
                }

                elements.forEach(e => this.observer.observe(e));
            });
    }

    // RTL.hr has proad box on frontpage where articleId is 0. To get articles on frontpage
    // we set articleId to 1 (should not be 0).
    getArticleId(): number {
        let articleId = this.options.articleId;

        if (!articleId && this.options.siteId === 30012) {
            articleId = 1;
        }

        return articleId;
    }

    loadDoc(params: any): void {
        let html = '';

        params.OutbrainPixels.forEach((pixel: string) => {
            html += '<img class="outbrain__pixel" src="' + pixel + '" />';
        })

        params.Pixels.forEach((pixel: string) => {
            html += '<img class="outbrain__pixel" src="' + pixel + '" />';
        })

        this.html.writeHTML('#proad-doc-' + params.Index, html);
    }

    private appendBanner(): void {
        if (this.options.isMobile || !window.ads?.banners || this.options.siteId === 30012) {
            return;
        }

        window.ads.banners.forEach((b: any) => {
            if (b.isProad) {
                const el = this.html.q('#' + b.slotElId);

                if (!el) {
                    return;
                }

                window.ads.defineSlot(b, true);
                window.ads.display(b);
            }
        });
    }
}

export default Proad;